// eslint-disable-next-line no-use-before-define
import * as React from "react";

const BlueArrow = (props) => (
	<svg width={8} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M7.54 6.29 1.88.64A1 1 0 1 0 .46 2.05l4.95 5L.46 12a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3.999.999 0 0 0 .71-.3l5.66-5.65a1 1 0 0 0 0-1.47Z"
			fill="#4378CB"
		/>
	</svg>
);

export default BlueArrow;
